import { useState } from 'react';
import { Menu, MenuItem, IconButton, Typography, DeleteForeverOutlinedIcon, EditIcon, 
    MoreHorizIcon } from 'src/components';
import { useIsMobile } from 'src/hooks';

export default function CommentMenu({ onEdit, onDelete }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const isMobile = useIsMobile();
    const fontSize = isMobile ? "subtitle1" : "body2";

    const handleEdit = () => {
        onEdit();
        handleClose();
    };

    const handleDelete = () => {
        onDelete();
        handleClose();
    };

    return (
        <>
        <IconButton
            size="small"
            disableRipple
            onClick={handleOpen}
            sx={{
                position: 'absolute',
                top: 8,
                right: 10,
                color: 'text.secondary'
            }}
        >
            <MoreHorizIcon fontSize="small" />
        </IconButton>

        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: 2,
                        minWidth: 110,
                        boxShadow: 3,
                    },
                },
            }}>

            <MenuItem
                onClick={handleEdit}
                disableRipple
                size="small"
                sx={{
                    fontSize: 13,
                    px: 1.5,
                    py: 0.75,
                    minHeight: 'auto',
                }}
                >
                <EditIcon fontSize="small" sx={{ mr: 1 }} />
                <Typography variant={fontSize}>Edit</Typography>
            </MenuItem>

            <MenuItem
                onClick={handleDelete}
                disableRipple
                size="small"
                sx={{
                    fontSize: 13,
                    px: 1.5,
                    py: 0.75,
                    minHeight: 'auto',
                }}
                >
                <DeleteForeverOutlinedIcon fontSize="small" sx={{ mr: 1 }} color="error" />
                <Typography color="error" variant={fontSize}>Delete</Typography>
            </MenuItem>
        </Menu>
        </>
    );
}
